import React, { useState, useEffect, Component } from 'react'
import {
  Button,
  Checkbox,
  CheckboxGroup,
  Col,
  ControlLabel,
  Input,
  Panel,
  Row,
  SelectPicker,
  Table,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { budgetFormat } from '../../utils/formatterUtil'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import { isRequired, isValidators } from '../../utils/ValidatorUtils'
import classNames from 'classnames'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { cloneDeep, value } from 'lodash-es'
import TablePagination from 'rsuite/lib/Table/TablePagination'
import {
  getManageUserEvaluateRoleGroup,
  getManageUserRoleGroupDeteil,
  saveManageUserRoleGroup,
} from '../../redux/actions/manageAccess'
import { doneLoading, startLoading } from '../../utils/loading'
import { getValueFromOptions } from '../../utils/dataUtil'
import notification from '../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function ManageEvaluationTeamRoleWidget(props) {
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const { Column, HeaderCell, Cell, Pagination } = Table
  const [formSchema, setFormSchema] = useState()
  const [formSearch, setFormSearch] = useState()
  const [expandedPanelMain, setExpandedPanelMain] = useState(true)
  const [header, setHeader] = useState('')
  const [isAddUser, setIsAddUser] = useState(false)
  const [actionStatus, setActionStatus] = useState()
  const [projectCodeSearch, setProjectCodeSearch] = useState()
  //const [roleCode, setRoleCode] = useState()
  const [projectCode, setProjectCode] = useState()
  const [evaluaterData, setEvaluaterData] = useState()
  const [isOTP, setIsOTP] = useState()

  const [tableData, setTableData] = useState([])
  const [displayLength, setDisplayLength] = useState(10)
  const [page, setPage] = useState(1)
  const [totalSize, setTotalSize] = useState(0)
  const defaultPage = 1
  const defaultLengthMenu = [
    { value: 10, label: 10 },
    { value: 20, label: 20 },
    { value: 40, label: 40 },
  ]
  const STA_EDIT = 'EDIT'
  const STA_ADD = 'ADD'

  const mockSchema = {
    header: '',
    subHeader: '',
    form: {
      projectVersion: '1111-1111-1111-111',
      projectCode: '67-10009',
      projectName: 'โครงการ AAAX',
      titleName: {
        label: 'คำนำหน้าชื่อ',
        name: 'titleName',
        value: '',
        options: [
          { disabled: false, label: 'นาย', value: '111-222-333-444' },
          { disabled: false, label: 'นางสาว', value: '666-777-888-999' },
        ],
        validators: [{ type: 'REQUIRED', value: null, errorMessage: 'เลือกคำนำหน้าชื่อ' }],
      },
      firstName: {
        label: 'ชื่อ',
        name: 'firstName',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก ชื่อ',
          },
        ],
      },
      lastName: {
        label: 'สกุล',
        name: 'lastName',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก สกุล',
          },
        ],
      },
      email: {
        label: 'e-mail',
        name: 'email',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก e-mail',
          },
        ],
      },
      telephone: {
        label: 'เบอร์มือถือ',
        name: 'telephone',
        value: '',
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณากรอก เบอร์มือถือ',
          },
        ],
      },
      loginBy: {
        label: 'เข้าสู่ระบบด้วย',
        name: 'loginBy',
        value: '',
        options: [
          { disabled: false, label: 'SSO', value: 'SSO' },
          { disabled: false, label: 'OTP', value: 'OTP' },
        ],
        validators: [
          {
            type: 'REQUIRED',
            value: null,
            errorMessage: 'กรุณาเลือก เข้าสู่ระบบด้วย',
          },
        ],
      },
      personnelOfProject: {
        label: 'ข้อมูลบุคคล',
        name: 'personnelOfProject',
        value: '',
        validators: null,
        options: [
          {
            label: 'นายอนุพงษ์  ชอบตกปลา',
            value: 'uuid-1234',
            titleNameId: '111-222-333-444',
            titleName: 'นาย',
            firstName: 'อนุพงษ์',
            lastName: 'ชอบตกปลา',
            telephone: '0909898765',
            email: 'jjjkkk@gmail.com',
          },
          {
            label: 'นายเฉลิมพงษ์ รักโลก',
            value: 'uuid-5678',
            titleNameId: '111-222-333-444',
            titleName: 'นาย',
            firstName: 'เฉลิมพงษ์',
            lastName: 'รักโลก',
            telephone: '0876543432',
            email: 'uadmin@gmail.com',
          },
        ],
      },
      values: [
        {
          roleId: '4',
          role: 'ทีมประเมินผล',
          lists: [
            {
              id: '6',
              titleName: 'นางสาว',
              firstName: 'พจนา',
              lastName: 'พุ่มเกตุ',
              fullName: 'นางสาวพจนา พุ่มเกตุ',
              email: 'ggg@gmail.com',
              telephone: '08-2094-xxx',
              loginBy: 'SSO',
            },
          ],
        },
      ],
    },
  }

  useEffect(() => {
    setFormSchema(props.schema)

    // console.log('formSchema => ', formSchema)
    if (props?.schema?.values?.length > 0) {
      setTableData(props.schema.values)
      setTotalSize(props.schema.totalSize)
    }
  }, [])

  const handleSearchManageMasterData = async (pageSize, pageNumber, projectCode) => {
    startLoading()
    try {
      const response = await getManageUserEvaluateRoleGroup(projectCode, pageSize, pageNumber)

      if (response) {
        setTableData(response.form.values || [])
        setTotalSize(response.form.totalSize || 0)
      }
    } catch (e) {
      console.log('e', e)
    }
    doneLoading()
  }

  const handleSearchProjectCode = () => {
    handleSearchManageMasterData(displayLength, 1, projectCodeSearch)
  }

  const onSubmit = (data) => {
    console.log('data => ', data)

    var request = {
      id: evaluaterData?.lists[0]?.id || null,
      titleName: getValueFromOptions(formSearch.form.titleName.options, data.titleName),
      firstName: data.firstName,
      lastName: data.lastName,
      //fullName: '',
      email: data.email,
      telephone: data.telephone,
      loginBy: data.loginBy,
      //loginByLabel: '',
      roleCode: evaluaterData?.roleId || 'SUB-EVL',
    }

    console.log('request ', request)
    handleOnSave(request)
  }

  const handleOnSave = async (request) => {
    startLoading()
    try {
      const response = await saveManageUserRoleGroup(request, projectCode, false)
      console.log('response', response)
      if (response) {
        setActionStatus(null)
        setExpandedPanelMain(true)
        //handleSearchProjectCode()
        handleSearchManageMasterData(displayLength, page, projectCodeSearch)
        //setFormSearch(response)
      }
    } catch (e) {
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const handleSelected = async (item, status) => {
    startLoading()
    try {
      const response = await getManageUserRoleGroupDeteil(item.projectCode, false)
      if (response) {
        setExpandedPanelMain(false)
        setActionStatus(status)
        setFormSearch(response)
        setProjectCode(item.projectCode)

        var evaluaterData = response?.form?.values.find((i) => i.roleId == 'SUB-EVL')
        if (evaluaterData) {
          setHeader(evaluaterData?.roleName || '')
          setEvaluaterData(evaluaterData)
        }

        if (evaluaterData?.lists?.length > 0 && status == STA_EDIT) {
          const s = response?.form
          const p = evaluaterData?.lists[0]
          const _titleName = response?.form?.titleName?.options?.find(
            (i) => i.label == p?.titleName
          )

          console.log('s', s)
          console.log('p', p)
          console.log('_titleName', _titleName)
          if (s && p && _titleName) {
            setValue(s.titleName.name, _titleName.value || '')
            setValue(s.firstName.name, p?.firstName || '')
            setValue(s.lastName.name, p?.lastName || '')
            setValue(s.telephone.name, p?.telephone || '')
            setValue(s.email.name, p?.email || '')
            setValue(s.loginBy.name, p?.loginBy || '')

            setIsOTP(p?.loginBy)
          }
        }

        clearErrors()

        //setIsAddUser(false)
      }
    } catch (e) {
      console.log('e', e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }
    doneLoading()
  }

  const onCancelSaveUser = () => {
    // setIsAddUser(false)
    setActionStatus(null)
    setExpandedPanelMain(true)
    setFormSearch(null)
    clearErrors()
  }

  const handleOnChangePersonnel = (id) => {
    console.log('handleOnChangePersonnel => ', id)
    const s = formSearch.form

    if (!id) {
      setValue(s.titleName.name, '')
      setValue(s.firstName.name, '')
      setValue(s.lastName.name, '')
      setValue(s.telephone.name, '')
      setValue(s.email.name, '')
      setValue(s.loginBy.name, '')

      setIsOTP()
      return false
    }

    const personals = cloneDeep(formSearch.form.personnelOfProject.options)

    if (personals.length > 0) {
      const p = personals.find((item) => item.value === id)

      setValue(s.titleName.name, p?.titleNameId || '')
      setValue(s.firstName.name, p?.firstName || '')
      setValue(s.lastName.name, p?.lastName || '')
      setValue(s.telephone.name, p?.telephone || '')
      setValue(s.email.name, p?.email || '')
      setValue(s.loginBy.name, p?.loginBy || '')

      setIsOTP(p?.loginBy)
    }
    clearErrors()
  }

  const handleEdit = (item) => {
    console.log('handleEdit')
    handleSelected(item, STA_EDIT)
  }

  const handleAddNew = (item) => {
    console.log('handleAddNew')
    handleSelected(item, STA_ADD)
  }

  const handleChangeLength = (dataKey) => {
    console.log('handleChangeLength dataKey', dataKey)
    setPage(1)
    setDisplayLength(dataKey)
    handleSearchManageMasterData(dataKey, 1, projectCodeSearch)
  }

  const handleChangePage = (dataKey) => {
    console.log('handleChangePage 111 page', dataKey)

    setPage(dataKey)
    handleSearchManageMasterData(displayLength, dataKey, projectCodeSearch)
  }

  return (
    <>
      {formSchema && (
        <Panel
          shaded
          header={formSchema.title}
          collapsible
          expanded={expandedPanelMain}
          onSelect={() => setExpandedPanelMain(!expandedPanelMain)}
        >
          <Row style={{ marginBottom: 20 }}>
            <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
              <div style={{ marginTop: 8 }}>{formSchema?.projectCode?.label || ''}</div>
            </Col>
            <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
              <Input
                placeholder={formSchema?.projectCode?.label || ''}
                onChange={(e) => setProjectCodeSearch(e)}
              />
            </Col>
            <Col lg={14} md={14} sm={14} xs={14} style={{ textAlign: 'left' }}>
              <SearchButton onClick={handleSearchProjectCode}>{formSchema.hedaer}</SearchButton>
            </Col>
          </Row>

          <table border={1} width={'100%'}>
            <tbody>
              <tr>
                <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    รหัสโครงการ
                  </div>
                </td>
                <td width={'25%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    ชื่อโครงการ
                  </div>
                </td>
                <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    สถานะ
                  </div>
                </td>
                <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    ทีมประเมินผล
                  </div>
                </td>
                <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    นักวิชาการ สสส.
                  </div>
                </td>
                {/* <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    หัวหน้าหน่วยจัดการ
                  </div>
                </td> */}
                {/* <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    สนับสนุนวิชาการ (พี่เลี้ยง)
                  </div>
                </td> */}

                <td width={'10%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    ผู้รับทุน
                  </div>
                </td>
                <td width={'5%'} style={{ backgroundColor: '#f2f2f5' }}>
                  <div
                    style={{
                      padding: 3,
                      marginTop: 3,
                      fontWeight: 'bold',
                      textAlign: 'center',
                    }}
                  >
                    จัดการ
                  </div>
                </td>
              </tr>
              {tableData.map((item, index) => {
                return (
                  <tr>
                    <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.projectCode}
                      </div>
                    </td>
                    <td width={'25%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          // textAlign: 'center',
                        }}
                      >
                        {item.projectName}
                      </div>
                    </td>
                    <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.projectStatusName}
                      </div>
                    </td>
                    <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.evaluationTeam}
                      </div>
                    </td>
                    <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.coordinatorName}
                      </div>
                    </td>
                    {/* <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.leaderManageName}
                      </div>
                    </td> */}
                    {/* <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.coordinatorSuportorName}
                      </div>
                    </td> */}

                    <td width={'10%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.granteeName}
                      </div>
                    </td>
                    <td width={'5%'}>
                      <div
                        style={{
                          padding: 3,
                          marginTop: 3,
                          fontWeight: 'bold',
                          textAlign: 'center',
                        }}
                      >
                        {item.evaluationTeam ? (
                          <>
                            <span style={{ cursor: 'pointer' }}>
                              <a
                                // onClick={() => {
                                //   handleSelected(item)
                                // }}
                                onClick={() => {
                                  handleEdit(item)
                                }}
                              >
                                แสดง
                              </a>
                            </span>
                          </>
                        ) : (
                          <>
                            <span style={{ cursor: 'pointer' }}>
                              <a
                                onClick={() => {
                                  handleAddNew(item)
                                }}
                                style={{ color: '#1d49f0c9' }}
                              >
                                เพิ่ม
                              </a>
                            </span>
                          </>
                        )}
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>

          <TablePagination
            lengthMenu={defaultLengthMenu}
            activePage={page}
            renderLengthMenu={(lengthMenu) => {
              return (
                <>
                  {lengthMenu}
                  {`รายการ/หน้า`}
                </>
              )
            }}
            renderTotal={(total) => {
              return <>{` ทั้งหมด ${total} รายการ`}</>
            }}
            displayLength={displayLength || 5}
            total={totalSize}
            onChangePage={handleChangePage}
            onChangeLength={handleChangeLength}
          />

          {/* <Table height={400} data={formSchema.values} wordWrap>
            <Column width={150} align="center" fixed>
              <HeaderCell>รหัสโครงการ</HeaderCell>
              <Cell dataKey="projectCode" />
            </Column>

            <Column width={200} fixed>
              <HeaderCell>ชื่อโครงการ</HeaderCell>
              <Cell dataKey="projectName" />
            </Column>

            <Column width={200}>
              <HeaderCell>สถานะ</HeaderCell>
              <Cell dataKey="projectStatusName" />
            </Column>

            <Column width={200}>
              <HeaderCell>นักวิชาการ สสส.</HeaderCell>
              <Cell dataKey="coordinatorName" />
            </Column>

            <Column width={200}>
              <HeaderCell>หัวหน้าหน่วยจัดการ</HeaderCell>
              <Cell dataKey="leaderManageName" />
            </Column>

            <Column width={300}>
              <HeaderCell>สนับสนุนวิชาการ (พี่เลี้ยง)</HeaderCell>
              <Cell dataKey="coordinatorSuportorName" />
            </Column>

            <Column width={300}>
              <HeaderCell>ทีมประเมินผล</HeaderCell>
              <Cell dataKey="evaluationTeam" />
            </Column>

            <Column width={300}>
              <HeaderCell>ผู้รับทุน </HeaderCell>
              <Cell dataKey="granteeName" />
            </Column>

            <Column width={80} fixed="right">
              <HeaderCell>Action</HeaderCell>

              <Cell style={{ textAlign: 'center' }}>
                {(rowData) => {
                  return (
                    <span style={{ cursor: 'pointer' }}>
                      <a
                        onClick={() => {
                          handleSelected(rowData)
                        }}
                      >
                        
                        แสดง
                      </a>
                    </span>
                  )
                }}
              </Cell>
            </Column>
          </Table> */}
        </Panel>
      )}

      {(actionStatus == STA_EDIT || actionStatus == STA_ADD) && formSearch && (
        <Panel
          shaded
          header={`โครงการ ${formSearch?.form?.projectCode} : ${formSearch?.form?.projectName}`}
          collapsible
          defaultExpanded
          style={{ marginTop: 20, marginBottom: 20 }}
        >
          {/* {isAddUser && ( */}
          <Panel header={`เพิ่มผู้ใช้งาน Role : ${header}`} bordered style={{ marginBottom: 20 }}>
            <Row style={{ marginTop: 10, marginBottom: 30 }}>
              <Col lg={2} md={2} sm={2} xs={2} />
              <Col lg={20} md={20} sm={20} xs={20}>
                <ControlLabel>{formSearch.form.personnelOfProject.label}</ControlLabel>
                <Controller
                  name={formSearch.form.personnelOfProject.name}
                  control={control}
                  defaultValue={formSearch.form.personnelOfProject.value}
                  // rules={isValidators(formSearch.form.personnelOfProject.validators)}
                  render={(props) => {
                    return (
                      // <SelectPicker
                      //   data={formSearch.form.personnelOfProject.options}
                      //   // disabled={disabledValue.constYear}
                      //   value={props.value}
                      //   block
                      //   placeholder="เลือก"
                      //   onChange={(value) => {
                      //     props.onChange(value)
                      //     // onChangeMainProject(value)
                      //   }}
                      // />
                      <SelectPicker
                        data={formSearch.form.personnelOfProject.options}
                        block
                        value={props.value}
                        placeholder="เลือก"
                        renderMenuItem={(label, item) => {
                          return (
                            <div style={{ fontWeight: 'bold', color: '#2da888' }}>
                              <i className="rs-icon rs-icon-user">{`  ${label}`}</i>
                              {/* <br /> */}
                              <i
                                className="rs-icon rs-icon-phone"
                                style={{
                                  paddingLeft: 15,
                                  color: '#9b9999',
                                }}
                              >{`  ${item?.telephone || ' - '}`}</i>
                              <i
                                className="rs-icon rs-icon-envelope"
                                style={{
                                  paddingLeft: 15,
                                  color: '#9b9999',
                                }}
                              >{`  ${item?.email || ' - '}`}</i>
                              <hr style={{ marginTop: 10, marginBottom: 'unset' }} />
                            </div>
                          )
                        }}
                        onChange={(value) => {
                          console.log('value => ', value)
                          props.onChange(value)
                          handleOnChangePersonnel(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              {/* <Col lg={10} md={10} sm={10} xs={10}></Col> */}
              <Col lg={2} md={2} sm={2} xs={2} />
            </Row>

            <Row>
              <Col lg={2} md={2} sm={2} xs={2} />
              <Col lg={4} md={4} sm={4} xs={4}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(formSearch.form.titleName.validators) && 'required'
                  )}
                >
                  {formSearch.form.titleName.label}
                </ControlLabel>
                <ErrorMessage error={errors.titleName} />
                <Controller
                  name={formSearch.form.titleName.name}
                  control={control}
                  defaultValue={formSearch.form.titleName.value}
                  rules={isValidators(formSearch.form.titleName.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={formSearch.form.titleName.options}
                        value={props.value}
                        block
                        searchable={false}
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={8} md={8} sm={8} xs={8}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(formSearch.form.firstName.validators) && 'required'
                  )}
                >
                  {formSearch.form.firstName.label}
                </ControlLabel>
                <ErrorMessage error={errors.firstName} />
                <Controller
                  name={formSearch.form.firstName.name}
                  control={control}
                  defaultValue={formSearch.form.firstName.value}
                  rules={isValidators(formSearch.form.firstName.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={formSearch.form.firstName.label}
                        value={props.value}
                        // maxLength={getMaxLengthData(formSearch.form.firstName.validators).value}
                        // disabled={isDisable}
                        onChange={(value, e) => {
                          // if (isNaN(value)) {
                          //   return
                          // }
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={8} md={8} sm={8} xs={8}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(formSearch.form.lastName.validators) && 'required'
                  )}
                >
                  {formSearch.form.lastName.label}
                </ControlLabel>
                <ErrorMessage error={errors.lastName} />
                <Controller
                  name={formSearch.form.lastName.name}
                  control={control}
                  defaultValue={formSearch.form.lastName.value}
                  rules={isValidators(formSearch.form.lastName.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={formSearch.form.lastName.label}
                        value={props.value}
                        // maxLength={getMaxLengthData(formSearch.form.lastName.validators).value}
                        // disabled={isDisable}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={2} md={2} sm={2} xs={2} />
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={2} md={2} sm={2} xs={2} />
              <Col lg={10} md={10} sm={10} xs={10}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(formSearch.form.telephone.validators) && 'required'
                  )}
                >
                  {formSearch.form.telephone.label}
                </ControlLabel>
                <ErrorMessage error={errors.telephone} />
                <Controller
                  name={formSearch.form.telephone.name}
                  control={control}
                  defaultValue={formSearch.form.telephone.value}
                  rules={isValidators(formSearch.form.telephone.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={formSearch.form.telephone.label}
                        value={props.value}
                        type="number"
                        // maxLength={getMaxLengthData(formSearch.form.telephone.validators).value}
                        // disabled={isDisable}
                        onChange={(value, e) => {
                          props.onChange(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={10} md={10} sm={10} xs={10}>
                <ControlLabel
                  className={isOTP != 1 && classNames(
                    'style-text-lable',
                    isRequired(formSearch.form.email.validators) && 'required'
                  )}
                >
                  {formSearch.form.email.label}
                </ControlLabel>
                <ErrorMessage error={errors.email} />
                <Controller
                  name={formSearch.form.email.name}
                  control={control}
                  defaultValue={formSearch.form.email.value}
                  rules={isOTP == 1 ? null : isValidators(formSearch.form.email.validators)}
                  render={(props) => (
                    <Input
                      placeholder={formSearch.form.email.label}
                      value={props.value}
                      // maxLength={getMaxLengthData(formSearch.form.email.validators).value}
                      // disabled={isDisable}
                      onChange={(value, e) => {
                        props.onChange(value)
                      }}
                    />
                  )}
                />
              </Col>
              <Col lg={2} md={2} sm={2} xs={2} />
            </Row>

            <Row style={{ marginTop: 10 }}>
              <Col lg={2} md={2} sm={2} xs={2} />
              <Col lg={10} md={10} sm={10} xs={10}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(formSearch.form.loginBy.validators) && 'required'
                  )}
                >
                  {formSearch.form.loginBy.label}
                </ControlLabel>
                <ErrorMessage error={errors.loginBy} />
                <Controller
                  name={formSearch.form.loginBy.name}
                  control={control}
                  defaultValue={formSearch.form.loginBy.value}
                  rules={isValidators(formSearch.form.loginBy.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={formSearch.form.loginBy.options}
                        value={props.value}
                        block
                        searchable={false}
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                          setIsOTP(value)

                          if(value == 1){
                            clearErrors(formSearch.form.email.name)
                          }
                        }}
                      />
                    )
                  }}
                />
              </Col>
              <Col lg={12} md={12} sm={12} xs={12}>
                <div style={{ marginTop: 23 }}>
                  <SaveButton children="บันทึก" onClick={handleSubmit(onSubmit)} />

                  <CancelButton
                    children="ยกเลิก"
                    onClick={() => {
                      onCancelSaveUser()
                    }}
                  />
                </div>
              </Col>
            </Row>
          </Panel>
          {/* )} */}

        </Panel>
      )}
    </>
  )
}
